import {UpdateMeCommand} from '@perfectpost/perfect-post-common';
import {useMutation, useQueryClient} from '@tanstack/react-query';

import {sendOrThrow} from '../../../services/sendOrThrow';
import {sessionKeys} from '../keys';
import type {MutationUiOptions} from '../../../utils/mutationMeta';

/**
 * Enregistre le mode d'apparence (système / clair / sombre) côté serveur.
 *
 * Remplace le thunk `updateAppearanceMode` de `src/store/mainslice.ts`.
 *
 * ⚠️ Le mode est aussi conservé LOCALEMENT par `PreferencesProvider` : le thème
 * doit s'appliquer au premier rendu, avant que `GET /me` n'ait répondu. C'est
 * `redux-persist` qui jouait ce rôle ; l'un ne remplace pas l'autre, ils sont
 * complémentaires.
 */
export function useUpdateAppearanceModeMutation(options: MutationUiOptions = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    ...options,
    mutationKey: [...sessionKeys.mutations(), 'appearanceMode'],
    mutationFn: ({appearanceMode}: {appearanceMode: 'system' | 'light' | 'dark'}) =>
      sendOrThrow(new UpdateMeCommand({appearanceMode})),
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: sessionKeys.me()});
    },
  });
}
